import * as React from "react";
import { useFormContext } from "react-hook-form";
import { CheckboxGroupFieldSchema, IInputFieldProps } from "@generation/core";
import { withHideOnFieldHoc } from "../Hoc/withHideOnFieldHoc";
import { withRegisterFieldHoc } from "../Hoc/withRegisterFieldHoc";
import { withRenderFieldHoc } from "../Hoc/withRenderFieldHoc";
import { CheckboxGroupInputFieldProps, CheckboxGroupInputField } from "@shared/common";
import { withValueSetHoc } from "../Hoc/withValueSetHoc";
import { onChangeHoc } from "../Hoc/onChangeHoc";

const RegisteredCheckboxGroupField = withRegisterFieldHoc(
  withRenderFieldHoc((props: IInputFieldProps<CheckboxGroupFieldSchema> & CheckboxGroupInputFieldProps) => (
    <CheckboxGroupInputField {...props} />
  ))
);

export const CheckboxGroupField = React.memo(
  onChangeHoc(
    withValueSetHoc(
      withHideOnFieldHoc((props: IInputFieldProps<CheckboxGroupFieldSchema>) => {
        const { watch } = useFormContext();
        const currentValue = watch(props.name);
        const uiInputDisplayStyle = props.field.ui?.inputDisplayStyle ?? "inline";

        return (
          <RegisteredCheckboxGroupField
            {...props}
            input={{ value: currentValue }}
            displayStyle={uiInputDisplayStyle}
            name={props.name}
            options={(props.field.options ?? []).map((item) => ({
              label: item.label,
              value: item.value,
              id: item.id
            }))}
          />
        );
      })
    )
  )
);
